<template>

    <ModalEditValorModulo :modulo="moduloEdit" :isVisible="isVisibleModalEditValorModulo" @close="isVisibleModalEditValorModulo = false"></ModalEditValorModulo>

    <div class="d-flex">

        <NavBarLeft path="/modulos"></NavBarLeft>

        <div class="flex-1">

            <HeaderPage title="Módulos" subtitle="Gerenciamento de módulos"></HeaderPage>

            <div class="m-2 p-2 bg-white">
                
                <BaseTable :columns="dataTableHead" :rows="modulosStore.modulos"
                    :paginationOptions="{ perPage: 50 }">

                    <template #table-row="{ column, row }">

                        <!-- Coluna de Ações -->
                        <template v-if="column.field == '__actions'">

                            <span>
                                <DropdownFloating v-model:shown="row.dropdownShown" :distance="6"
                                    placement="left-start">

                                    <div class="">
                                        <i class="ri-more-fill cursor-pointer"></i>
                                    </div>


                                    <template #popper>
                                        <div class="p-2 d-flex gap-2 flex-column">

                                            <OptionActionDataTable @click="openModalEditValorModulo(row)" text="Editar Valor" icon="ri-pencil-line">
                                            </OptionActionDataTable>

                                        </div>
                                    </template>
                                </DropdownFloating>
                            </span>

                        </template>

                        <!-- Colunas de valor -->
                        <template v-else-if="column.field == 'valor'">
                            {{ $moneyConvert.convert(row.valor) }}
                        </template>

                        <!-- Colunas normais -->
                        <template v-else>
                            {{ row[column.field] }}
                        </template>
                    </template>

                </BaseTable>

            </div>

        </div>

    </div>
</template>


<script>
import ModalEditValorModulo from '@/components/modais/ModalEditValorModulo.vue'
import {useModulosStore} from '@/stores/modulos.js'

export default {
    name: 'AppPage',
    data() {
        return {

            dataTableHead:
                [
                    { label: 'Id', field: 'id', tdClass: 'td-vertical-middle' },
                    { label: 'Nome', field: 'nome', tdClass: 'td-vertical-middle' },
                    { label: 'Id Externo', field: 'id_externo', tdClass: 'td-vertical-middle' },
                    { label: 'Valor por usuário', field: 'valor', tdClass: 'td-vertical-middle' },
                    { label: 'Ações', field: '__actions', sortable: false, tdClass: 'td-actions td-vertical-middle text-center' }
                ]
            ,
            modulosStore: useModulosStore(),


            isVisibleModalEditValorModulo: false,
            moduloEdit: {}
        }
    },
    components: { ModalEditValorModulo },
    methods: {
        openModalEditValorModulo(modulo){
            modulo.dropdownShown = false
            this.moduloEdit = modulo
            this.isVisibleModalEditValorModulo = true
        }
    },
    mounted() {
        this.modulosStore.get()
    }
}
</script>